/**
 * useSectionSpy — B-2026-0086, B-2026-0088
 *
 * Scroll-spy hook for EvaluationResults. Watches all elements with a
 * `data-guide-section` attribute inside the page and reports the topmost
 * one intersecting the upper-middle portion of the viewport to the
 * AdaptiveGuideContext via `report({ activeSection })`.
 *
 * B-2026-0088 Phase A2: this file is now a one-line re-export of `useAnchorSpy`
 * with the `data-guide-section` attribute name pre-bound. All logic lives in
 * `useAnchorSpy.ts`. Eval + its existing tests are untouched.
 *
 * Usage (unchanged):
 * ```tsx
 * useSectionSpy(report);
 * ```
 */

import { useAnchorSpy } from './useAnchorSpy';
import type { AdaptiveGuideState } from '@/contexts/AdaptiveGuideContext';

type ReportFn = (partial: Partial<AdaptiveGuideState>) => void;

export function useSectionSpy(report: ReportFn): void {
  useAnchorSpy(report, 'data-guide-section');
}
